import React, { useState, useEffect } from "react";
import '../styles/VideoPlayerPage.css';
import { useLocation, useNavigate } from 'react-router-dom';
import VideoPlayerSidebar from "../components/VideoPlayerSidebar";
import Header from "../components/Header";
import home from "../images/home.png"; // Icons for sidebar
import feedback from "../images/feedback.png";
import tutorials from "../images/tutorials.png";
import history from "../images/history.png";
import video_icon from "../images/video_icon.png";
import user_management from "../images/user_management.png";
import license_management from '../images/license_management.png';
import VideoPlayer from "../components/VideoPlayer";
import VideoPlayerTags from "../components/VideoPlayerTags";
import VideoPlayerTitle from "../components/VideoPlayerTitle";
import VideoPlayerDescription from "../components/VideoPlayerDescription";
import Videos from "../components/Videos";
import { getProfile } from '../Storage/Storage'; // Import the getProfile function

const VideoPlayerPage = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [menuItems, setMenuItems] = useState([]);
  const videoLocation = useLocation();
  const navigate = useNavigate();
  const { video, videoData } = videoLocation.state || {};
  const videoUrl = video?.file?.url || video?.videofile?.url || "";

  useEffect(() => {
    const fetchProfile = async () => {
      const profile = await getProfile();
      const items = getMenuItemsByProfile(profile);
      setMenuItems(items);
    };
  
    fetchProfile();
  }, []);
  

  // Function to determine the menu items based on user profile
  const getMenuItemsByProfile = (profile) => {
    if (profile === "Moderator") {
      return [
          { icon: video_icon, label: "Manage Videos ", key: "video_management" },
          { icon: user_management, label: "Manage Users", key: "user_management" },
          { icon: license_management, label: "Manage Licenses", key: "license_management" },
          { icon: feedback, label: "Feedback", key: "feedback" },
          { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true }
        ];
    } else if (profile === "Student") {
      return [
        { icon: home, label: "Home", key: "home" },
        { icon: feedback, label: "Feedback", key: "feedback" },
        { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true},
        { icon: history, label: "History", key: "history", disabled: true },
      ];
    } else if (profile === "Teacher") {
      return [
        { icon: home, label: "Home", key: "home" },
        { icon: feedback, label: "Feedback", key: "feedback" },
        { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
        { icon: history, label: "History", key: "history", disabled: true },
      ];
    }
    return [];
  };

  // Function to handle navigation based on the selected menu item
  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route based on the item key and profile
    const profile = localStorage.getItem("profile");
    
    if (profile === "Moderator") {
      if (item === "video_management") {
        navigate("/moderator/video-management");
      } else if (item === "user_management") {
        navigate("/moderator/user-management");
      } else if (item === "feedback") {
        navigate("/moderator/feedback");
      } else if (item === "tutorials") {
        navigate("/admin/tutorials");
      } else if (item === "license_management") {
        navigate("/moderator/license-management");
      }
    } else if (profile === "Student") {
      if (item === "home") {
        navigate("/learner");
      } else if (item === "feedback") {
        navigate("/learner/feedback");
      }
    } else if (profile === "Teacher") {
      if (item === "home") {
        navigate("/teacher");
      } else if (item === "feedback") {
        navigate("/teacherFeedback");
      }
    }

    resetSearch(); // Reset search when a new section is selected
  };

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery("");
  };

  const renderContentSuggestedVideos = () => {
    return <Videos videoData={videoData || []} />;
  };

  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  const handleSearch = (query) => {
    setSearchQuery(query);
    setActiveItem("");
  };

  return (
    <div className="videoPlayer-dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={handleSearch}
        showSearch={showSearch}
      />
      <main className="videoPlayer-main-content">
        <VideoPlayerSidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={menuItems}
          onMenuItemClick={handleActiveItemChange} // Handle menu item click
          resetSearch={resetSearch}
        />
        <div className="videoPlayer-content">
          <VideoPlayer videoUrl={videoUrl} />
          <div className="videoPlayer-tags">
            <VideoPlayerTags tags={video?.tags} />
          </div>
          <div className="videoPlayer-title">
            <VideoPlayerTitle title={video?.title} />
          </div>
          <div className="videoPlayer-description">
            <VideoPlayerDescription description={video?.description} />
          </div>
        </div>
        <div>
          <div className="videoPlayer-suggested-videos">
            <span>Suggested Videos</span>
          </div>
          {renderContentSuggestedVideos()}
        </div>
      </main>
    </div>
  );
};

export default VideoPlayerPage;
